import { Image } from "antd";
import React, { useEffect, useState } from "react";
export const ImageCard = ({isMobile, title,keyForAPi, initialImage = null, onImageChange,leadDetail }) => {
    const [image, setImage] = useState(initialImage);
    const [isUploading, setIsUploading] = useState(false);
    useEffect(() => {
      setImage(initialImage)
    }, [initialImage])
    
    const handleUpload = async (e) => {
      const file = e.target.files[0];
      if (file) {
        setIsUploading(true);
        
        // Read file as data URL for preview
        const reader = new FileReader();
        reader.onload = (e) => {
          const imageData = e.target.result;
          setImage(imageData);
          
          // Send to parent component for API handling
          onImageChange(title,keyForAPi, file, imageData);
          setIsUploading(false);
        };
        reader.readAsDataURL(file);
      }
    };
  
    const handleDelete = () => {
      setImage(null);
      // Notify parent component about deletion
      onImageChange(title,keyForAPi, null, null);
    };
  
    return (
      <div className="k-card">
        {image ? (
          <Image 
                      alt={`Image for ${title}`} 
            className="k-card-media k-responsive-height" 
            src={image} 
          />
          // <img 
          //   alt={`Image for ${title}`} 
          //   className="k-card-media k-responsive-height" 
          //   src={image} 
          // />
        ) : (
          <div 
          className="k-responsive-height"
            style={{
              backgroundColor: "#f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <p>No image</p>
          </div>
        )}
        
        <div style={{minHeight:title=="Inside Super Gutter"  && !isMobile ? "80px" : ''}}>
          <h3 className="k-ml-3 k-sm-mini-heading">{title}</h3>
        </div>
        
  {!leadDetail?.mhalt &&      <div className="k-card-footer">
          <div className="k-d-flex k-justify-content-between k-w-full k-display-responsive">
            <label style={{textAlign:"center"}} className={`k-button-green k-button-md ${isUploading ? 'k-disabled' : ''}`}>
              {isUploading ? "Uploading..." : (image ? "Replace" : "Upload")}
              <input 
                type="file" 
                accept="image/*" 
                onChange={handleUpload} 
                style={{ display: "none" }} 
                disabled={isUploading}
              />
            </label>
            
            {image && (
              <button 
                onClick={handleDelete}
                className="k-button-red2 k-button-md"
                disabled={isUploading}
              >
                Delete
              </button>
            )}
          </div>
        </div>}
      </div>
    );
  };